<!-- 로그인: 왼쪽 사진 / 오른쪽 로그인 영역 (좁은 화면에서는 사진 위 가운데 카드) -->
<div class="login-page">
    <div class="login-visual">
        <!-- <img src="/assets/manna/login/login-bg-1.jpg"> -->
        <img class="background-img" src="/assets/app/login/login_bg_p2.png">
        <div class="login-visual-text">
            <img class="login-visual-logo" src="/assets/app/logo/SIL_Horizontal_White_trim.png" alt="SINDAEDONG INTERNATIONAL LOGISTICS">
        </div>
    </div>
    <!-- <img class="sls-logo" src="/assets/app/login/sls-logo-img.png"> -->

    <div class="login-panel">
        <div class="login-card">
            <!-- <div style="border-top: 3px solid #057feb;width: 9rem;height: 1rem;"></div> -->
            <form class="npx-login-form" #ngForm1="ngForm" (ngSubmit)="ngForm1.valid && ngForm1Submit()">
                <div class="login-title">
                    <!-- <img class="sls-icon" src="/assets/app/login/sls_logo.png"> -->
                    <img class="sil-logo" src="/assets/app/logo/SIL_Symbol_Color_trim.png" alt="SIL">
                    <h3 class="mb-0">신대동 Dealer</h3>
                </div>
                <p class="login-sub">계정 정보를 입력하세요</p>
                <div class="form-floating mt-4">
                    <input type="email" class="form-control" id="floatingInput" name="accountName"
                        [(ngModel)]="data.accountName" required placeholder="name@example.com">
                    <label for="floatingInput">아이디</label>
                </div>
                <div class="form-floating mt-3">
                    <input type="password" class="form-control" id="floatingPassword" name="accountPasswd"
                        [(ngModel)]="data.accountPasswd" required placeholder="Password">
                    <label for="floatingPassword">비밀번호</label>
                </div>
                <div class="form-check mt-3 mb-4 pb-1">
                    <input type="checkbox" class="form-check-input" id="loginRememberMe" name="rememberMe"
                        [(ngModel)]="data.rememberMe">
                    <label class="form-check-label" for="loginRememberMe">로그인 정보 기억하기</label>
                </div>

                <button class="w-100 btn btn-lg btn-primary" type="submit">로그인</button>
            </form>
        </div>
        <p class="login-copyright">&copy; 2026 SHINHWA LOGISTICS SERVICE CO., LTD.</p>
    </div>
</div>
